import { ReactNode } from "react";

import { TooltipProvider } from "../basic/tooltip";
import { alertData, AlertProvider, useAlertContext } from "./alert";
import { ModalProvider, useModalContext } from "./modal";

interface ContextProps {
	children: ReactNode;
}

export { useModalContext, useAlertContext };
export type { alertData };

export function TLPProviders(props: ContextProps) {
	return (
		<AlertProvider>
			<TooltipProvider>
				<ModalProvider>{props.children}</ModalProvider>
			</TooltipProvider>
		</AlertProvider>
	);
}
